import {
  AfterViewInit,
  Component,
  ElementRef,
  EventEmitter, forwardRef,
  HostBinding,
  Input,
  OnChanges, OnDestroy,
  OnInit,
  Output, SimpleChanges,
  ViewChild
} from '@angular/core';
import {ControlValueAccessor, FormsModule, NG_VALUE_ACCESSOR} from '@angular/forms';
import {NgIf} from '@angular/common';

@Component({
  selector: 'app-input-text',
  templateUrl: './input-text.component.html',
  standalone: false,
  styleUrl: './input-text.component.scss',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => InputTextComponent),
      multi: true,
    },
  ]
})
export class InputTextComponent implements OnInit, ControlValueAccessor, OnChanges, OnDestroy, AfterViewInit {

    @Input() public label: string;
    @Input() public name: string;
    @Input() public autofocus: boolean;
    @Input() public checkAutofill: string;
    @Input() public autocomplete = 'off';
    @Input() public required: boolean | string;
    @Input() public type = 'text';

    @HostBinding('class.with-placeholder') @Input() public placeholder: string;

    // tslint:disable-next-line:no-input-rename
    @Input('disabled') isDisabledInput: boolean | number | '';
    @HostBinding('class.disabled') isDisabled: boolean;


    @HostBinding('class.active') isActive: boolean;
    @HostBinding('class.has-value') public value: string;

    @ViewChild('inputElement') inputElement: ElementRef;

    @Output() public blur: EventEmitter<any> = new EventEmitter<any>();
    @Output() public focus: EventEmitter<any> = new EventEmitter<any>();


    private continueAutofillChecking = true;

    constructor() {
    }

    ngOnInit(): void {
    }

    get isRequired(): boolean {
        return this.required === '' || this.required === true;
    }


    public propagateChange: (_: any) => void = (_: any) => {
    };

    public onTouched: () => void = () => {
    };

    public registerOnChange(fn: any): void {
        this.propagateChange = fn;
    }

    public registerOnTouched(fn: any): void {
        this.onTouched = fn;
    }

    public writeValue(value: string): void {
        this.value = value;
    }

    onBlur(inputElement: HTMLInputElement) {
        this.onTouched();
        this.isActive = false;
        if (inputElement.value && !this.value) {
            this.value = inputElement.value;
            this.propagateChange(this.value);
        }
        this.blur.emit();
    }

    onNgModelChanged() {
        this.propagateChange(this.value);
        // console.log('this.inputElement', this.inputElement);
    }

    ngOnChanges(changes: SimpleChanges): void {


        if (this.isDisabledInput !== '') {
            // set via angular [disabled] attribute
            this.isDisabled = !!this.isDisabledInput;
        } else {
            // set via attribute disabled only
            this.isDisabled = true;
        }

        if (this.checkAutofill) {
            window.addEventListener('click', this.onOutsideClick, false);
            this.checkAutofillValue(2);
        }
    }

    onFocus() {
        this.isActive = true;
        this.focus.emit();
    }

    checkAutofillValue(timeOut: number) {
        setTimeout((_: any) => {
            if (this.continueAutofillChecking) {
                let autofilledInputs: NodeListOf<Element>;
                if (this.name) {
                    autofilledInputs = document.querySelectorAll('#' + this.name + ':-webkit-autofill ');
                    // console.log('checkAutofillValue', autofilledInputs.length);
                    if (autofilledInputs.length) {
                        autofilledInputs.forEach(input => {
                            input.parentElement.parentElement.classList.add('has-value');
                            input.parentElement.parentElement.classList.add('autofilled');
                            this.continueAutofillChecking = false;
                            window.removeEventListener("click", this.onOutsideClick);
                        });
                    } else {
                        // console.log('this.forceLabelTop', this.forceLabelTop);
                        // this.forceLabelTop = true
                    }

                }

                if (this.continueAutofillChecking) {
                    this.checkAutofillValue(timeOut);
                }
            }
        }, timeOut)
    }

    onOutsideClick = (e: Event) => {
        window.removeEventListener("click", this.onOutsideClick);
        this.continueAutofillChecking = false;
    };

    ngOnDestroy(): void {
        window.removeEventListener("click", this.onOutsideClick);
    }


    public handleAutofocus() {
        setTimeout(() => {
            if (this.autofocus && this.inputElement) {
                this.inputElement?.nativeElement.focus();
            }
            this.autocomplete = Math.random().toString();
        }, 0);
    }

    ngAfterViewInit() {
        this.handleAutofocus();
    }

    getLabel() {
        return this.label + (this.isRequired ? '*' : '');
    }
}
